import relic1Img from '../../assets/relic1.png';
import relic2Img from '../../assets/relic2.png';
import relic3Img from '../../assets/relic3.png';
import relic4Img from '../../assets/relic4.png';
import relic5Img from '../../assets/relic5.png';
import relic6Img from '../../assets/relic6.png';
import relic7Img from '../../assets/relic7.png';
import relic8Img from '../../assets/relic8.png';
import relic9Img from '../../assets/relic9.png';
import relic10Img from '../../assets/relic10.png';
import relic11Img from '../../assets/relic11.png';
import relic12Img from '../../assets/relic12.png';
import relic13Img from '../../assets/relic13.png';
import relic14Img from '../../assets/relic14.png';
import relic15Img from '../../assets/relic15.png';
import relic16Img from '../../assets/relic16.png';
import relic17Img from '../../assets/relic17.png';
import relic18Img from '../../assets/relic18.png';
import relic19Img from '../../assets/relic19.png';
import relic20Img from '../../assets/relic20.png';
import relic21Img from '../../assets/relic21.png';
import relic22Img from '../../assets/relic22.png';
import relic23Img from '../../assets/relic23.png';
import relic24Img from '../../assets/relic24.png';
import relic25Img from '../../assets/relic25.png';
import relic26Img from '../../assets/relic26.png';
import relic27Img from '../../assets/relic27.png';
import relic28Img from '../../assets/relic28.png';
import relic29Img from '../../assets/relic29.png';
import relic30Img from '../../assets/relic30.png';
import relic31Img from '../../assets/relic31.png';
import relic32Img from '../../assets/relic32.png';
import relic33Img from '../../assets/relic33.png';
import relic34Img from '../../assets/relic34.png';
import relic35Img from '../../assets/relic35.png';
import relic36Img from '../../assets/relic36.png';
import relic37Img from '../../assets/relic37.png';
import relic38Img from '../../assets/relic38.png';
import relic39Img from '../../assets/relic39.png';
import relic40Img from '../../assets/relic40.png';
import relic41Img from '../../assets/relic41.png';
import relic42Img from '../../assets/relic42.png';
import relic43Img from '../../assets/relic43.png';
import relic44Img from '../../assets/relic44.png';
import relic45Img from '../../assets/relic45.png';
import relic46Img from '../../assets/relic46.png';
import relic47Img from '../../assets/relic47.png';
import relic48Img from '../../assets/relic48.png';
import relic49Img from '../../assets/relic49.png';
import relic50Img from '../../assets/relic50.png';
import relic51Img from '../../assets/relic51.png';
import relic52Img from '../../assets/relic52.png';
import relic53Img from '../../assets/relic53.png';
import relic54Img from '../../assets/relic54.png';
import relic55Img from '../../assets/relic55.png';
import relic56Img from '../../assets/relic56.png';
import relic57Img from '../../assets/relic57.png';
import relic58Img from '../../assets/relic58.png';
import relic59Img from '../../assets/relic59.png';
import relic60Img from '../../assets/relic60.png';
import relic61Img from '../../assets/relic61.png';
import relic62Img from '../../assets/relic62.png';
import relic63Img from '../../assets/relic63.png';
import relic64Img from '../../assets/relic64.png';
import relic65Img from '../../assets/relic65.png';
import relic66Img from '../../assets/relic66.png';
import relic67Img from '../../assets/relic67.png';
import relic68Img from '../../assets/relic68.png';
import relic69Img from '../../assets/relic69.png';
import relic70Img from '../../assets/relic70.png';
import relic71Img from '../../assets/relic71.png';
import relic72Img from '../../assets/relic72.png';
import relic73Img from '../../assets/relic73.png';
import relic74Img from '../../assets/relic74.png';
import relic75Img from '../../assets/relic75.png';
import relic76Img from '../../assets/relic76.png';
import relic77Img from '../../assets/relic77.png';
import relic78Img from '../../assets/relic78.png';
import relic79Img from '../../assets/relic79.png';
import relic80Img from '../../assets/relic80.png';
import relic81Img from '../../assets/relic81.png';
import relic82Img from '../../assets/relic82.png';

/**
 * Relics/Trinkets
 * - `combat` fields are aggregated and passed into the combat engine.
 * - `effect(ctx)` is applied once when the relic is acquired (for immediate gains / one-shot flags).
 * - `dungeon` fields are aggregated and used by the dungeon crawler.
 *
 * Notes:
 * - Combat mods stack additively across owned relics.
 * - Dungeon hooks (onOpenChest/onLightTorch/onRest) are executed immediately when those actions occur.
 */

export const RELIC_RARITIES = ['common', 'uncommon', 'rare', 'mythic'];
export const RELIC_RARITY_BY_ID = {
  'beholders-eye': 'mythic',
  'compass': 'mythic',
  'explorers-backpack': 'mythic',
  'spire-schematics': 'mythic',
  'inverted-heart': 'mythic',

  'light-link': 'rare',
  'scarred-bandage': 'rare',
  'ration-charm': 'rare',
  'berserker-brand': 'rare',
  'aegis-mirror': 'rare',
  'locksmith-charm': 'rare',
  'light-link': 'rare',
  'dealing-die': 'rare',
  'threshold-reliquary': 'rare',
  'sealed-receipt': 'rare',
  'fine-sand-hourglass': 'rare',
  'lead-ribbon': 'rare',
  'arcane-flame': 'rare',

  'bare-blade': 'uncommon',
  'mirror-shard': 'uncommon',
  'pale-lantern': 'uncommon',
  'torchwick-charm': 'uncommon',
  'smoke-knot': 'uncommon',
  'cinder-sigil': 'uncommon',
  'grave-salt-vial': 'uncommon',
  'grave-ward': 'uncommon',
  'padded-boots': 'uncommon',
  'razor-ward': 'uncommon',
  'preserved-skull': 'uncommon',
  'hidden-dagger': 'uncommon',
  'untarnished-candle': 'uncommon',
  'muted-inkwell': 'uncommon',
  'zero-key': 'uncommon',
  'lightened-buckle': 'uncommon',
  'ballast-shield': 'uncommon',
  'threshold-coin': 'uncommon',
  'double-plated-cuirass': 'uncommon',
  'scavengers-pouch': 'uncommon',
  'torch-bag': 'uncommon',
  'potion-belt': 'uncommon',
  'fancy-purse': 'uncommon',
  'metal-torch': 'uncommon',
  'stillstone': 'uncommon',
  'pilgrims-token': 'uncommon',
  'echo-ring': 'uncommon',
  'bottomless-pouch': 'uncommon',
};

const RAW_RELICS = [
  // ============================================================
  // Combat-focused (power + survival)
  // ============================================================
  
  // ------------------------------------------------------------
  // New relics/trinkets added for extended mechanics. These
  // entries currently define only basic metadata (id, name,
  // description, image) to ensure the code continues to compile.
  // The actual gameplay hooks (e.g., on discard, reflect damage,
  // card draw triggers) are not yet implemented; they would require
  // additional support in the combat and dungeon engine.
  {
    id: 'dull-shiv',
    name: 'Ashen Shard',
    description: 'Combat: Whenever you discard a card, gain 5 SP.',
    image: relic1Img,
    combat: { onDiscardGainSp: 5 },
  },
  {
    id: 'brine-vial',
    name: 'Widow’s Brine',
    description: 'Combat: Whenever you discard a card, gain 5 HP.',
    image: relic2Img,
    combat: { onDiscardGainHp: 5 },
  },
  {
    id: 'hollow-chime',
    name: 'Vacant Toll',
    description: 'Combat: If you have no cards in hand at the end of your turn, draw 1 card.',
    image: relic4Img,
    combat: { endTurnEmptyDraw: 1 },
  },
  {
    id: 'fifth-finger-ring',
    name: 'Pentarch Loop',
    description: 'Combat: If you have 5 cards in hand at the end of your turn, gain 10 Armor.',
    image: relic3Img,
    combat: { endTurnFiveCardsArmor: 10 },
  },
  {
    id: 'palm-brooch',
    name: 'Grasp Sigil',
    description: 'Combat: At the end of your turn, gain 2 Armor for each card in your hand.',
    image: relic5Img,
    combat: { endTurnArmorPerCard: 2 },
  },
  {
  id: 'double-plated-cuirass',
  name: 'Oathbound Carapace',
  description: 'Combat: Double the Armor you gain from cards. Lose 40 Maximum HP.',
  image: relic6Img,
  // -40 max HP (App.js treats dungeon.maxHp/maxHpBonus as bonuses, not absolute)
  dungeon: { maxHpBonus: -40 },
  combat: { doubleArmorGainFromCards: true },
},
  {
    id: 'threshold-coin',
    name: 'Last Mint',
    description: 'Combat: If you have 20 SP or less, you deal 20 more damage.',
    image: relic34Img,
    combat: { attackBonusWhenLowSp: 20, lowSpThreshold: 20 },
  },
  {
    id: 'mirror-rosary',
    name: 'Penitent Facets',
    description: 'Combat: Whenever you reflect damage, gain 10 HP.',
    image: relic28Img,
    combat: { reflectBonusHp: 10 },
  },
  {
    id: 'mercury-locket',
    name: 'Silver Pulse Locket',
    description: 'Combat: Whenever you reflect damage, gain 10 SP.',
    image: relic9Img,
    combat: { reflectBonusSp: 10 },
  },
  {
    id: 'quicksilver-lens',
    name: 'Diviner’s Refraction',
    description: 'Combat: Whenever you reflect damage, draw 1 card (max. 5 cards in hand).',
    image: relic10Img,
    combat: { reflectBonusDraw: 1 },
  },
  {
    id: 'lead-ribbon',
    name: 'Gravebind Sash',
    description: 'Combat: Immune to Stun.',
    image: relic11Img,
    combat: { immuneStun: true },
  },
  {
    id: 'ivory-tooth',
    name: 'Zero Fang',
    description: 'Combat: Whenever you defeat an enemy leaving its HP exactly at 0, gain 3 extra Teeth.',
    image: relic12Img,
    combat: { ivoryTooth: 3 },
  },
  {
    id: 'bottomless-pouch',
    name: 'Feaster’s Purse',
    description: 'Combat: If you would draw cards but your hand is full (max 5), gain 10 HP for each card you would have drawn.',
    image: relic7Img,
    combat: { fullHandGainHpOnDraw: 10 },
  },
  {
    id: 'ballast-shield',
    name: 'Cathedral Ballast',
    description: 'Combat: If your deck has 30 cards or more at the start of combat, reduce damage you take by 10.',
    image: relic33Img,
    combat: { damageReductionIfLargeDeck: 10 },
  },
  {
    id: 'fine-sand-hourglass',
    name: 'Choirglass',
    description: 'Combat: If your deck has 30 cards or more at the start of combat, reduce your cards’ Delay by 1.',
    image: relic35Img,
    combat: { reduceDelayForLargeDeck: 1 },
  },
  {
    id: 'tardy-bracer',
    name: 'Afterblow Cuff',
    description: 'Combat: Whenever you play a card with Delay, gain 5 Armor.',
    image: relic19Img,
    combat: { delayCardArmor: 5 },
  },
  {
    id: 'lightened-buckle',
    name: 'Hollow Clasp',
    description: 'Combat: Cards with Delay cost 5 less SP.',
    image: relic8Img,
    combat: { delayCostReduction: 5 },
  },
  {
    id: 'zero-key',
    name: 'Zero Key',
    description: 'Combat: Whenever your SP is exactly 0, gain 20 SP.',
    image: relic15Img,
    combat: { spGainWhenZero: 20 },
  },
  {
    id: 'muted-inkwell',
    name: 'Silted Inkwell',
    description: 'Combat: All Addendum costs are reduced by 5.',
    image: relic14Img,
    combat: { addendumCostReduction: 5 },
  },
  {
    id: 'sealed-receipt',
    name: 'Red Ledger Seal',
    description: 'Combat: If you played 7 cards with Addendum from your hand and paid all Addendum costs, gain 50 SP at the end of combat.',
    image: relic16Img,
    combat: { gainSpOnPayAddendumThreshold: 7, gainSpAmount: 50 },
  },
  {
    id: 'untarnished-candle',
    name: 'Saint’s Pyrewick',
    description: 'Combat: If you recieved no enemy damage by the end of combat, lose 50 HP and gain 5 Teeth.',
    image: relic36Img,
    combat: { untarnishedCandleLoseHp: 50, untarnishedCandleTeeth: 5 },
  },

  {
  id: 'threshold-reliquary',
  name: 'Brink Shrine',
  description: 'Combat: If your SP is 20 or less at the end of combat, increase the loot quantity from that combat.',
  image: relic25Img,
  combat: { brinkShrineLootQuantityBonus: 2 },
  },

  {
    id: 'dealing-die',
    name: 'Reliquary Die',
    description: 'Combat: Whenever you draw a card beyond the first each turn, gain 10 SP per card drawn.',
    image: relic21Img,
    combat: { drawBeyondFirstGainSp: 10 },
  },
  {
    id: 'bare-blade',
    name: 'Unhoused Edge',
    description: 'Combat: Whenever your Armor is 0, you deal 10 more damage.',
    image: relic29Img,
    combat: { attackBonusWhenArmorZero: 10 },
  },
  {
    id: 'light-link',
    name: 'Gleam Circuit',
    description: 'Combat: Reduce the SP cost of all Chain cards by 2.',
    image: relic26Img,
    combat: { chainCostReduction: 2 },
  },
  {
    id: 'first-exile-seal',
    name: 'Fractured Writ',
    description: 'Combat: The first Exile card you play each combat does not Exile.',
    image: relic27Img,
    combat: { firstExileDontExile: true },
  },
{
    id: 'hidden-dagger',
    name: 'Hidden Dagger',
    description: 'Combat: At the start of each of your turns, your first Attack deals +10 damage.',
    image: relic37Img,
    combat: { turnStartAttackBonus: 10 },
  },
{
    id: 'iron-bracers',
    name: 'Iron Bracers',
    description: 'Combat: Start each combat with +20 Armor.',
    image: relic32Img,
    combat: { startArmor: 20 },
  },
{
    id: 'preserved-skull',
    name: 'Preserved Skull',
    description: 'Combat: Draw 1 random extra card at the start of combat (max. 5).',
    image: relic38Img,
    combat: { firstTurnExtraDraw: 1 },
  },
  {
    id: 'scarlet-heart',
    name: "Scarlet Heart",
    description: 'Exploration & Combat: Increase your maximum HP by +20.',
    image: relic39Img,
    dungeon: { maxHp: 20 },
  },
{
    id: 'soul-cistern',
    name: "Soul Cistern",
    description: 'Exploration & Combat: Increase your maximum SP by +20.',
    image: relic40Img,
    dungeon: { maxSp: 20 },
  },
  {
  id: 'razor-ward',
  name: "Razor Ward",
  description: 'Combat: Your attacks deal an extra +5 damage.',
  image: relic68Img,
  combat: { attackBonusFlat: 5 },
},
{
    id: 'padded-boots',
    name: "Padded Boots",
    description: 'Exploration: Reduce the chance to activate traps.',
    image: relic67Img,
    dungeon: { trapActivationChanceMultiplier: 0.5 },
  },
{
    id: 'locksmith-charm',
    name: "Locksmith's Charm",
    description: 'Exploration: Once per floor, you may open a locked chest without spending a key.',
    image: relic66Img,
    dungeon: { freeChestPerFloor: 1 },
  },
{
    id: 'bone-dice',
    name: 'Bone Dice',
    description: 'Exploration: Opening a chest grants +2 Teeth.',
    image: relic65Img,
    dungeon: { onOpenChest: { teeth: 2 } },
  },
{
    id: 'chalk-idol',
    name: 'Chalk Idol',
    description: 'Exploration: Resting restores an additional +2% Sanity.',
    image: relic64Img,
    dungeon: { onRest: { sanityPct: 2 } },
  },
  {
    id: 'aegis-mirror',
    name: 'Aegis Mirror',
    description: 'Combat: Start combat with 50% Reflect and negate the first damage you would take.',
    image: relic63Img,
    combat: { startReflectPct: 50, startNegateNextDamage: 1 },
  },
{
    id: 'berserker-brand',
    name: "Berserker Brand",
    description: 'Combat: Start combat with -10 HP, but at the start of each of your turns your next Attack deals +20 damage.',
    image: relic62Img,
    combat: { startHp: -10, turnStartAttackBonus: 20 },
  },
{
    id: 'grave-ward',
    name: 'Grave Ward',
    description: 'Exploration: Opening a chest restores +20 HP. Combat: Start combat with 25% Reflect.',
    image: relic61Img,
    combat: { startReflectPct: 25 },
    dungeon: { onOpenChest: { hp: 20 } },
  },
{
    id: 'grave-salt-vial',
    name: 'Grave Salt Vial',
    description: 'Exploration: Opening a chest restores +20 SP. Combat: Start combat with +30 Armor.',
    image: relic60Img,
    combat: { startArmor: 30 },
    dungeon: { onOpenChest: { sanity: 20 } },
  },
  {
    id: 'cinder-sigil',
    name: 'Cinder Sigil',
    description: 'Exploration: When you light a torch, you start next combat with +50 Armor.',
    image: relic59Img,
    dungeon: { onLightTorch: { nextCombatStartArmor: 50 } },
  },
  {
    id: 'smoke-knot',
    name: 'Smoke Knot',
    description: 'Exploration: Once per floor, you may slip past an enemy without fighting. Combat: Negate the first damage you would take.',
    image: relic57Img,
    dungeon: { bypassEnemyPerFloor: 1 },
    combat: { startNegateNextDamage: 1 },
  },
{
    id: 'stealth-ring',
    name: 'Stealth Ring',
    description: 'Exploration: Once per floor, you may slip past an enemy without fighting.',
    image: relic56Img,
    dungeon: { bypassEnemyPerFloor: 1 },
  },
  {
    id: 'lockpicks-set',
    name: "Set of Lockpicks",
    description: 'Exploration: Increase your key capacity by 1.',
    image: relic50Img,
    dungeon: { maxKeysBonus: 1 },
  },
  {
    id: 'scavengers-pouch',
    name: "Scavenger's Pouch",
    description: 'Exploration: Increase your key capacity by 3.',
    image: relic51Img,
    dungeon: { maxKeysBonus: 3 },
  },
  {
    id: 'torch-cache',
    name: 'Torch Cache',
    description: 'Exploration: Increase your torch capacity by 1.',
    image: relic52Img,
    dungeon: { maxTorchesBonus: 1 },
  },
  {
    id: 'torch-bag',
    name: 'Torch Bag',
    description: 'Exploration: Increase your torch capacity by 3.',
    image: relic53Img,
    dungeon: { maxTorchesBonus: 3 },
  },
  {
    id: 'evil-chalice',
    name: 'Evil Chalice',
    description: 'Exploration: Increase your potion capacity by 1.',
    image: relic54Img,
    dungeon: { maxPotionsBonus: 1 },
  }, 
  {
    id: 'potion-belt',
    name: 'Potion Belt',
    description: 'Exploration: Increase your potion capacity by 3.',
    image: relic55Img,
    dungeon: { maxPotionsBonus: 3 },
  },
  {
    id: 'leather-pouch',
    name: 'Leather Pouch',
    description: 'Exploration: Increase your teeth capacity by 1.',
    image: relic41Img,
    dungeon: { maxTeethBonus: 1 },
  },
  {
    id: 'fancy-purse',
    name: 'Fancy Purse',
    description: 'Exploration: Increase your teeth capacity by 3.',
    image: relic75Img,
    dungeon: { maxTeethBonus: 3 },
  },
  {
    id: 'torchwick-charm',
    name: 'Torchwick Charm',
    description: 'Exploration: When you light a torch, restore +25 Sanity.',
    image: relic58Img,
    dungeon: { onLightTorch: { sanity: 25 } },
  },
{
    id: 'ration-charm',
    name: 'Rations',
    description: 'Exploration: Resting restores +2% HP.',
    image: relic49Img,
    dungeon: { onRest: { hpPct: 2 } },
  },
{
    id: 'pale-lantern',
    name: 'Pale Lantern',
    description: 'Exploration: +1 vision radius. Opening chests restores +20 Sanity.',
    image: relic48Img,
    dungeon: { visionBonus: 1, onOpenChest: { sanity: 20 } },
  },
  {
    id: 'cartographers-tooth',
    name: "Cartographer's Notes",
    description: 'Exploration: +1 vision radius (torch + braziers).',
    image: relic47Img,
    dungeon: { visionBonus: 1 },
  },
  {
    id: 'mirror-shard',
    name: 'Mirror Shard',
    description: 'Combat: Start combat with 80% Reflect, but lose -5 HP at combat start.',
    image: relic45Img,
    combat: { startReflectPct: 80, startHp: -5 },
  },
  {
    id: 'scarred-bandage',
    name: 'Scarred Bandage',
    description: 'Combat: Start each combat with +10 HP.',
    image: relic46Img,
    combat: { startHp: 10 },
  },
  {
    id: 'monks-hourglass',
    name: "Monk's Hourglass",
    description: 'Combat: Negate the first instance of damage you would take each combat.',
    image: relic44Img,
    combat: { startNegateNextDamage: 1 },
  },
  {
    id: 'execution-token',
    name: 'Voodoo Doll',
    description: 'Combat: At the start of each of your turns, your first Attack deals +5 damage.',
    image: relic43Img,
    combat: { turnStartAttackBonus: 5 },
  },
    {
    id: 'arcane-flame',
    name: 'Arcane Flame',
    description: 'Exploration: Improves the duration of your torches.',
    image: relic76Img,
    dungeon: { torchDurationBonus: 32 },
  },
  {
    id: 'metal-torch',
    name: 'Metal Torch',
    description: 'Exploration: Improves the duration of your torches.',
    image: relic78Img,
    dungeon: { torchDurationBonus: 16 },
  },
  {
    id: 'spire-schematics',
    name: 'Spire Schematics',
    description: 'Exploration: Start each floor with a fully discovered map.',
    image: relic77Img,
    dungeon: { revealMapOnFloorStart: true },
  },
  {
    id: 'stillstone',
    name: 'Stillstone',
    description: 'Combat: Improves your Focus.',
    image: relic79Img,
    combat: { focusBonusSP: 10 },
  },
  {
    id: 'pilgrims-token',
    name: "Pilgrim's Token",
    description: 'Combat: Focus also grants HP.',
    image: relic80Img,
    combat: { focusBonusHP: 10 },
  },
  {
    id: 'echo-ring',
    name: 'Echo Ring',
    description: "Combat: You don't have a draw penalty when using Recast.",
    image: relic81Img,
    combat: { recastDrawPenalty: 0 },
  },
  {
    id: 'old-coin',
    name: 'Old Coin',
    description: 'A gold coin. It is worthless in this place.',
    image: relic71Img,
    dungeon: {},
  },
  {
    id: 'beholders-eye',
    name: "Eye of the Beholder",
    description: 'See enemy intentions.',
    image: relic72Img,
    combat: { revealEnemyIntentPreview: true },
  },
  {
    id: 'compass',
    name: "Compass",
    description: 'It hints towards the exit steps.',
    image: relic73Img,
    dungeon: { compassHint: true },
  },
  {
    id: 'explorers-backpack',
    name: "Explorer's Backpack",
    description: 'Increase the amount of trinkets you can carry by 4.',
    image: relic74Img,
    dungeon: { trinketLimitBonus: 4 },
  },
  {
    id: 'inverted-heart',
    name: 'Inverted Heart',
    description: 'Combat: Healing above your max HP becomes Armor. Armor gained above your cap becomes SP.',
    image: relic82Img,
    combat: { invertedHeart: true },
  },
];

export const relicsPool = RAW_RELICS.map((r) => ({
  ...r,
  rarity: RELIC_RARITY_BY_ID[r.id] || 'common',
}));

// --- Rarity helpers (kept here so editing rarities stays easy) ---

export const getRelicRarity = (relicOrId) => {
  const id = typeof relicOrId === 'string' ? relicOrId : relicOrId?.id;
  if (!id) return 'common';
  // Prefer the explicit map, but fall back to any explicit field on the relic object.
  return RELIC_RARITY_BY_ID[id] || (typeof relicOrId === 'object' ? relicOrId?.rarity : null) || 'common';
};

export const formatRelicRarity = (rarity) => {
  const r = String(rarity || 'common').toLowerCase();
  if (r === 'mythic') return 'Mythic';
  if (r === 'rare') return 'Rare';
  if (r === 'uncommon') return 'Uncommon';
  return 'Common';
};

// Default weights match your comment expectations: mostly common, some uncommon, few rare.
export const rollRelicRarity = (
  rng = Math.random,
  weights = { common: 70, uncommon: 22, rare: 6, mythic: 2 }
) => {
  const roll = (typeof rng === 'function' ? rng() : Math.random()) * 100;
  const c = Number(weights.common) || 0;
  const u = Number(weights.uncommon) || 0;
  const r = Number(weights.rare) || 0;

  if (roll < c) return 'common';
  if (roll < c + u) return 'uncommon';
  if (roll < c + u + r) return 'rare';
  return 'mythic';
};

/**
 * Picks relics from a pool based on rarity.
 *
 * - If `desiredRarity` is a string (or omitted), returns ONE relic.
 * - If `desiredRarity` is a number, returns up to that many unique relics.
 */
export const pickRelicsByRarity = (pool, desiredRarity, rng = Math.random, weights) => {
  const list = Array.isArray(pool) ? pool.filter(Boolean) : [];
  if (!list.length) return typeof desiredRarity === 'number' ? [] : null;

  const rand = typeof rng === 'function' ? rng : Math.random;
  const pickOne = (source, rarityOverride) => {
    const rarity = rarityOverride || rollRelicRarity(rand, weights);
    const filtered = source.filter((r) => getRelicRarity(r) === rarity);
    const eligible = filtered.length ? filtered : source;
    if (!eligible.length) return null;
    const idx = Math.floor(rand() * eligible.length);
    return eligible[idx] || null;
  };

  if (typeof desiredRarity === 'number' && Number.isFinite(desiredRarity)) {
    const count = Math.max(0, Math.floor(desiredRarity));
    const remaining = [...list];
    const picks = [];
    for (let i = 0; i < count && remaining.length > 0; i += 1) {
      const picked = pickOne(remaining);
      if (!picked) break;
      picks.push(picked);
      const idx = remaining.findIndex((r) => r?.id === picked?.id);
      if (idx >= 0) remaining.splice(idx, 1);
    }
    return picks;
  }

  const rarity = typeof desiredRarity === 'string' && desiredRarity ? desiredRarity : undefined;
  return pickOne(list, rarity);
};

